import i18n from "i18next";

export const getLangParams = () => {
  const language = i18n.language;
  return language === "en" ? "" : `${language}/`;
};
